// src/utils/judoCategories.js
/* =========================
   Catégories de poids "référence"
   ========================= */
export const weightCategories = {
  Benjamin: ["-26", "-30", "-34", "-38", "-42", "-46", "-50", "-55", "-60", "-66", "+66 kg"],
  Minime: ["-34", "-38", "-42", "-46", "-50", "-55", "-60", "-66", "-73", "+73 kg"],
  Cadet: ["-46", "-50", "-55", "-60", "-66", "-73", "-81", "-90", "+90 kg"],
  Junior: ["-55", "-60", "-66", "-73", "-81", "-90", "-100", "+100 kg"],
  Sénior: ["-60", "-66", "-73", "-81", "-90", "-100", "+100 kg"],
  BenjaminF: ["-28", "-32", "-36", "-40", "-44", "-48", "-52", "-57", "-63", "+63 kg"],
  MinimeF: ["-36", "-40", "-44", "-48", "-52", "-57", "-63", "-70", "+70 kg"],
  CadetF: ["-40", "-44", "-48", "-52", "-57", "-63", "-70", "+70 kg"],
  JuniorF: ["-44", "-48", "-52", "-57", "-63", "-70", "-78", "+78 kg"],
  SéniorF: ["-48", "-52", "-57", "-63", "-70", "-78", "+78 kg"],

  // Tranches morphologiques → on affichera des "chips" par poids réel: "23 kg", "24 kg", ...
  Eveil: ["Groupes Morphologiques"],
  MiniPoussin: ["Groupes Morphologiques"],
  Poussin: ["Groupes Morphologiques"],
  EveilF: ["Groupes Morphologiques"],
  MiniPoussinF: ["Groupes Morphologiques"],
  PoussinF: ["Groupes Morphologiques"],

  // Vétérans
  M1: ["-60", "-66", "-73", "-81", "-90", "-100", "+100 kg"],
  M2: ["-60", "-66", "-73", "-81", "-90", "-100", "+100 kg"],
  M3: ["-60", "-66", "-73", "-81", "-90", "-100", "+100 kg"],
  M4: ["-60", "-66", "-73", "-81", "-90", "-100", "+100 kg"],
  M5: ["-60", "-66", "-73", "-81", "-90", "-100", "+100 kg"],
  M6: ["-60", "-66", "-73", "-81", "-90", "-100", "+100 kg"],
  M7: ["-60", "-66", "-73", "-81", "-90", "-100", "+100 kg"],
  M8: ["-60", "-66", "-73", "-81", "-90", "-100", "+100 kg"],
  M9: ["-60", "-66", "-73", "-81", "-90", "-100", "+100 kg"],
  M10: ["-60", "-66", "-73", "-81", "-90", "-100", "+100 kg"],
  M11: ["-60", "-66", "-73", "-81", "-90", "-100", "+100 kg"],
  F1: ["-48", "-52", "-57", "-63", "-70", "-78", "+78 kg"],
  F2: ["-48", "-52", "-57", "-63", "-70", "-78", "+78 kg"],
  F3: ["-48", "-52", "-57", "-63", "-70", "-78", "+78 kg"],
  F4: ["-48", "-52", "-57", "-63", "-70", "-78", "+78 kg"],
  F5: ["-48", "-52", "-57", "-63", "-70", "-78", "+78 kg"],
  F6: ["-48", "-52", "-57", "-63", "-70", "-78", "+78 kg"],
  F7: ["-48", "-52", "-57", "-63", "-70", "-78", "+78 kg"],
  F8: ["-48", "-52", "-57", "-63", "-70", "-78", "+78 kg"],
  F9: ["-48", "-52", "-57", "-63", "-70", "-78", "+78 kg"],
  F10: ["-48", "-52", "-57", "-63", "-70", "-78", "+78 kg"],
  F11: ["-48", "-52", "-57", "-63", "-70", "-78", "+78 kg"],
};

/* =========================
   Helpers SAISON
   ========================= */
export const getCurrentSeasonStartYear = (d = new Date()) => {
  const y = d.getFullYear();
  const m = d.getMonth(); // saison commence 1er août
  return m >= 7 ? y : y - 1;
};
export const seasonStringFromStartYear = (startYear) => `${startYear}-${startYear + 1}`;
export const parseSeasonStartYear = (s) => parseInt(s.split("-")[0], 10);

/* =========================
   Tranches d’âge
   ========================= */
export const AGE_BANDS = [
  { key: "Eveil", labelM: "Eveil", labelF: "Eveil", minAge: 5, maxAge: 6 },
  { key: "MiniPoussin", labelM: "Mini-Poussin", labelF: "Mini-Poussine", minAge: 7, maxAge: 8 },
  { key: "Poussin", labelM: "Poussin", labelF: "Poussine", minAge: 9, maxAge: 10 },
  { key: "Benjamin", labelM: "Benjamin", labelF: "Benjamine", minAge: 11, maxAge: 12 },
  { key: "Minime", labelM: "Minime", labelF: "Minime", minAge: 13, maxAge: 14 },
  { key: "Cadet", labelM: "Cadet", labelF: "Cadette", minAge: 15, maxAge: 17 },
  { key: "Junior", labelM: "Junior", labelF: "Junior", minAge: 18, maxAge: 20 },
  { key: "Sénior", labelM: "Sénior", labelF: "Sénior", minAge: 21, maxAge: Infinity },
];

export const VETERANS = [
  { keyM: "M1", keyF: "F1", minAge: 30, maxAge: 34, label: "Vétéran" },
  { keyM: "M2", keyF: "F2", minAge: 35, maxAge: 39, label: "Vétéran" },
  { keyM: "M3", keyF: "F3", minAge: 40, maxAge: 44, label: "Vétéran" },
  { keyM: "M4", keyF: "F4", minAge: 45, maxAge: 49, label: "Vétéran" },
  { keyM: "M5", keyF: "F5", minAge: 50, maxAge: 54, label: "Vétéran" },
  { keyM: "M6", keyF: "F6", minAge: 55, maxAge: 59, label: "Vétéran" },
  { keyM: "M7", keyF: "F7", minAge: 60, maxAge: 64, label: "Vétéran" },
  { keyM: "M8", keyF: "F8", minAge: 65, maxAge: 69, label: "Vétéran" },
  { keyM: "M9", keyF: "F9", minAge: 70, maxAge: 74, label: "Vétéran" },
  { keyM: "M10", keyF: "F10", minAge: 75, maxAge: 79, label: "Vétéran" },
  { keyM: "M11", keyF: "F11", minAge: 80, maxAge: Infinity, label: "Vétéran" },
];

/* =========================
   Génération du tableau “théorique”
   ========================= */
export const yearRange = (endYear, minAge, maxAge) => {
  if (maxAge === Infinity) {
    const fromYear = endYear - minAge;
    return `${fromYear} et avant`;
  }
  const start = endYear - maxAge; // plus ancien
  const end = endYear - minAge;   // plus récent
  return `${start} - ${end}`;
};

export const buildCategoriesForSeason = (seasonStr) => {
  const startYear = parseSeasonStartYear(seasonStr);
  const endYear = startYear + 1;
  const rows = [];

  AGE_BANDS.forEach(({ key, labelM, labelF, minAge, maxAge }) => {
    const annees = yearRange(endYear, minAge, maxAge);
    rows.push({ label: labelM, annees, ageCategory: key, genre: "Masculin" });
    rows.push({ label: labelF, annees, ageCategory: key + "F", genre: "Féminin" });
  });
  VETERANS.forEach(({ keyM, keyF, minAge, maxAge, label }) => {
    const annees = yearRange(endYear, minAge, maxAge);
    rows.push({ label: `${label} ${keyM}`, annees, ageCategory: keyM, genre: "Masculin" });
    rows.push({ label: `${label} ${keyF}`, annees, ageCategory: keyF, genre: "Féminin" });
  });
  return rows;
};

/* =========================
   Calculs d’affectation
   ========================= */
export const getAgeAtEndOfSeason = (dobStr, seasonStr) => {
  if (!dobStr) return null;
  const startYear = parseSeasonStartYear(seasonStr);
  const endYear = startYear + 1;
  const endDate = new Date(`${endYear}-12-31T12:00:00`);
  const [y, m, d] = dobStr.split("T")[0].split("-").map((n) => parseInt(n, 10));
  const birth = new Date(`${y}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}T12:00:00`);
  let age = endDate.getFullYear() - birth.getFullYear();
  const mdiff = endDate.getMonth() - birth.getMonth() || endDate.getDate() - birth.getDate();
  if (mdiff < 0) age--;
  return age;
};

export const getAgeCategoryKey = (age, genre) => {
  if (age == null || isNaN(age)) return null;
  if (age >= 80) return genre === "Féminin" ? "F11" : "M11";
  if (age >= 75) return genre === "Féminin" ? "F10" : "M10";
  if (age >= 70) return genre === "Féminin" ? "F9" : "M9";
  if (age >= 65) return genre === "Féminin" ? "F8" : "M8";
  if (age >= 60) return genre === "Féminin" ? "F7" : "M7";
  if (age >= 55) return genre === "Féminin" ? "F6" : "M6";
  if (age >= 50) return genre === "Féminin" ? "F5" : "M5";
  if (age >= 45) return genre === "Féminin" ? "F4" : "M4";
  if (age >= 40) return genre === "Féminin" ? "F3" : "M3";
  if (age >= 35) return genre === "Féminin" ? "F2" : "M2";
  if (age >= 30) return genre === "Féminin" ? "F1" : "M1";

  let baseKey = null;
  for (const band of AGE_BANDS) {
    if (age >= band.minAge && (band.maxAge === Infinity || age <= band.maxAge)) {
      baseKey = band.key;
      break;
    }
  }
  if (!baseKey) return null;
  return genre === "Féminin" && weightCategories[`${baseKey}F`] ? `${baseKey}F` : baseKey;
};

const parseKg = (s) => {
  const m = String(s).match(/\d+/);
  return m ? parseInt(m[0], 10) : null;
};

export const isMorpho = (ageKey) => {
  const list = weightCategories[ageKey] || [];
  return list.includes("Groupes Morphologiques");
};

/**
 * Retourne un "bracket" lisible.
 * - Catégories officielles: "-34", "+73 kg", etc.
 * - Morphologiques: on regroupe par poids réel → "23 kg", "24 kg", ...
 */
export const getWeightBracket = (ageKey, poids) => {
  const list = weightCategories[ageKey] || [];
  if (!list.length) return null;

  // Morphologique → clé dynamique par poids réel
  if (isMorpho(ageKey)) {
    const p = Number(poids);
    if (Number.isFinite(p) && p > 0) return `${p} kg`;
    return null;
  }

  // Officiel → mappage habituel
  for (const entry of list) {
    if (entry.startsWith("-")) {
      const lim = parseKg(entry);
      if (lim != null && poids < lim) return entry;
    } else if (entry.startsWith("+")) {
      continue;
    } else {
      const lim = parseKg(entry);
      if (lim != null && poids === lim) return entry;
    }
  }
  const plus = list.find((e) => e.startsWith("+"));
  return plus || null;
};
